export default {
	get: {
		
	},
	post: {
		skuStockPage: '/dmall-manage/dmallmanage/groupSkuStock/page',
		skuStockDownload: '/dmall-manage/dmallmanage/groupSkuStock/download',
  }
}